module.exports = __webpack_public_path__ + "fannie-mae-card-bottom-right@2x.289kcAmx.png";